import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBackup = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M15.2071 10.7929C15.5976 11.1834 15.5976 11.8166 15.2071 12.2071L12.7071 14.7071C12.3166 15.0976 11.6834 15.0976 11.2929 14.7071L8.79289 12.2071C8.40237 11.8166 8.40237 11.1834 8.79289 10.7929C9.18342 10.4024 9.81658 10.4024 10.2071 10.7929L11 11.5858V5C11 4.44772 11.4477 4 12 4C12.5523 4 13 4.44772 13 5V11.5858L13.7929 10.7929C14.1834 10.4024 14.8166 10.4024 15.2071 10.7929Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M2 14C2 12.8954 2.89543 12 4 12H6C6.55228 12 7 12.4477 7 13C7 13.5523 6.55228 14 6 14H4V18H20V14H18C17.4477 14 17 13.5523 17 13C17 12.4477 17.4477 12 18 12H20C21.1046 12 22 12.8954 22 14V18C22 19.1046 21.1046 20 20 20H4C2.89543 20 2 19.1046 2 18V14Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8 16C8 16.5523 7.55228 17 7 17C6.44772 17 6 16.5523 6 16C6 15.4477 6.44772 15 7 15C7.55228 15 8 15.4477 8 16Z",
			fill: "currentColor"
		})
	]
});
export default SvgBackup;
